import { useEffect, useMemo, useState } from 'react';
import {
  subscribeAcreditacionesDelDia,
  subscribeControlesDelDia,
  subscribeMetaDelDia,
} from '../services/acreditacionesEsperadasService';
import { mergeAcreditaciones } from '../utils/acreditacionesEsperadas';

/**
 * Acreditaciones esperadas de `fecha` (cálculo desde el SGC + marcas del
 * operador). `comitentes` = null en modo staff; en modo productor, su padrón.
 *
 * `meta` en null con `isLoading` false significa que no hay dato del SGC para
 * el día: la UI tiene que decirlo y no mostrar "nada esperado".
 */
export const useAcreditacionesEsperadas = ({ user, fecha, comitentes = null }) => {
  const [docs, setDocs] = useState([]);
  const [controles, setControles] = useState([]);
  const [meta, setMeta] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const comitentesKey = Array.isArray(comitentes) ? comitentes.join('|') : null;

  useEffect(() => {
    if (!user || !fecha) {
      setDocs([]);
      setControles([]);
      setMeta(null);
      setIsLoading(false);
      return undefined;
    }
    setIsLoading(true);
    setError(null);
    const filtro = comitentesKey === null ? null : (comitentesKey ? comitentesKey.split('|') : []);
    const onError = (err) => {
      setError(err);
      setIsLoading(false);
    };
    const unsubs = [
      subscribeMetaDelDia(fecha, (data) => {
        setMeta(data);
        setIsLoading(false);
      }, onError),
      subscribeAcreditacionesDelDia(fecha, filtro, setDocs, onError),
      subscribeControlesDelDia(fecha, filtro, setControles, onError),
    ];
    return () => unsubs.forEach(unsub => unsub());
  }, [user, fecha, comitentesKey]);

  const porComitente = useMemo(() => mergeAcreditaciones(docs, controles), [docs, controles]);

  return { porComitente, meta, isLoading, error };
};
